module.exports = __webpack_public_path__ + "static/media/banner-thatsit.a001c9be.png";